// const closeBtn = document.querySelectorAll(".modal__close");

MicroModal.init({
  openClass: "is-open",
  disableScroll: true,
  onClose: (modal) => {
    let temp = document.querySelectorAll(".ytframe");
    temp.forEach((ytframe) => {
      console.log(this);
      let temp2 = ytframe.getAttribute("src");
      ytframe.setAttribute("src", "");
      ytframe.setAttribute("src", temp2);
    });
  },
});